import { apiProxyRequest } from "Api/apiProxyRequest";

export interface ProjectAddon {
  id: string;
  project_id: string;
  type: string;
  status: string;
  quantity?: number;
  title: string;
  unit?: string;
  sku?: string;
  allowed_values?: (number | string)[];
  // Per-plan allowed values (environments addon): the values valid for each
  // plan, so a plan change can pick a value compatible with the target plan.
  plan_options?: Record<string, number[]>;
  _links: {
    self: { href: string };
  };
}

export interface ProjectAddonsList {
  count: number;
  items: ProjectAddon[];
}

export const getProjectAddonsRequest = ({
  organizationId,
  projectId
}: {
  organizationId: string;
  projectId: string;
}) =>
  apiProxyRequest<ProjectAddonsList>(
    `/organizations/${organizationId}/projects/${projectId}/addons`
  );
